import authService from "@/services/auth";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("Authentication", ["authUser"]),
    userRole() {
      const roles = this.authUser.roles || [];
      const companyId = this.$store.state.Company.companyInfo.id;
      return roles
        .filter((role) => role.companyId == companyId)
        .map((role) => role.roleName);
    },
    isTutor() {
      const roles = this.authUser.roles;
      const company = this.$store.state.Company.companyInfo.id;
      for (var i = 0; i < roles.length; i++) {
        if (
          roles[i].roleName.search("tutor/") != "-1" &&
          roles[i].companyId == company
        ) {
          return true;
        }
      }
    },
    IsTutorAdmin() {
      const roles = this.authUser.roles;
      const company = this.$store.state.Company.companyInfo.id;
      for (var i = 0; i < roles.length; i++) {
        if (
          roles[i].roleName.search("tutor/admin") != "-1" &&
          roles[i].companyId == company
        ) {
          return true;
        }
      }
    },
    isTutorInstructor() {
      const roles = this.authUser.roles;
      const company = this.$store.state.Company.companyInfo.id;
      for (var i = 0; i < roles.length; i++) {
        if (
          roles[i].roleName.search("tutor/instructor") != "-1" &&
          roles[i].companyId == company
        ) {
          return true;
        }
      }
    },
    isOrgAdmin() {
      const roles = this.authUser.roles;
      const company = this.$store.state.Company.companyInfo.id;
      for (var i = 0; i < roles.length; i++) {
        if (
          roles[i].roleName.search("org/admin") != "-1" &&
          roles[i].companyId == company
        ) {
          return true;
        }
      }
    },
    isInstructor() {
      const roles = this.authUser.roles;
      const company = this.$store.state.Company.companyInfo.id;
      for (var i = 0; i < roles.length; i++) {
        if (
          roles[i].roleName.search("/instructor") != "-1" &&
          roles[i].companyId == company
        ) {
          return true;
        }
      }
    },
    isOrgInstructor() {
      const roles = this.authUser.roles;
      const company = this.$store.state.Company.companyInfo.id;
      for (var i = 0; i < roles.length; i++) {
        if (
          roles[i].roleName.search("org/instructor") != "-1" &&
          roles[i].companyId == company
        ) {
          return true;
        }
      }
    },
    canManageMember() {
      return this.hasPermissions(["crud-member"]);
    },
    canEnrollMember() {
      return this.hasPermissions([
        "crud-individual-enrollment",
        "crud-group-enrollment",
      ]);
    },
    canSpecificUserAccess() {
      if (this.m_Id == 283814 && this.comId == 408) {
        return true;
      }
      return false;
    },
    isWannasorn() {
      return [1000001, 1000002, 1000003].includes(this.comId);
    },
  },

  data() {
    return {
      tempHasPermissions: null,
      comId: JSON.parse(localStorage.getItem("ComId")),
      m_Id: JSON.parse(localStorage.getItem("user")).id,
    };
  },
  methods: {
    getCurrentUser() {
      return {
        roles: this.userRole,
        comType: this.$store.state.Company.companyInfo.companyType,
        comId: this.comId,
        mId: this.m_Id,
      };
    },
    hasRoles(roles) {
      return roles.find((roleName) => {
        return this.authUser.roles.find((role) => {
          return (
            role.roleName == roleName && role.companyId === this.company.id
          );
        });
      });
    },
    hasPermissions(permissions) {
      authService.hasPermissions(permissions).then((result) => {
        this.tempHasPermissions = result;
      });

      return this.tempHasPermissions;
    },
    isAccountingType() {
      if (this.comId == 485 || this.comId == 513 || this.comId == 519) {
        return true;
      }
    },
    isInsuranceType() {
      if (
        this.comId == 470 ||
        this.comId == 500 ||
        this.comId == 502 ||
        this.comId == 503 ||
        this.comId == 506
      ) {
        return true;
      }
    },
    isTutorType() {
      let companyType = this.$store.state.Company.companyInfo.companyType;
      let exceptComIds = [513, 519, 485];
      if (
        (companyType == "WHITELABEL_TUTOR" || companyType == "TRAINER") &&
        !exceptComIds.includes(this.comId)
      ) {
        return true;
      }
    },
    isCorporateType() {
      let companyType = this.$store.state.Company.companyInfo.companyType;
      if (companyType == "WHITELABEL_ORG")
      {
        return true;
      }
    },
    isAllowedToSpecificCompany(accessObject) {
      const openPreqCourse = [
        3, // coursesquare
        180, // tuemaster
        277, // abig
        512, // tguru
        508, // ajgolf
        527, // theplanner
        524, // pdpc
        525, // dpoaas
        485, // tfac
        513, // nyc
        519, // dharmniti
        470, // trainingplus
        502, // rsquare
        503, // thaire
      ];

      if (accessObject === 'enroll-course-button') {
        // tguru, pdpc, dpoaas, dharmniti, socialnock (1 user)
        if (this.isInsuranceType() || this.isCorporateType() || this.comId == 512 || this.comId == 524 || this.comId == 525 || (this.comId == 528 && this.m_Id == 149400)) {
          return true;
        }
      } else if (accessObject === 'add-member-button') {
        if (this.isInsuranceType() || this.isCorporateType() || this.comId == 512 || this.comId == 524 || this.comId == 525) {
          return true;
        } 
      } else if (accessObject === 'add-user-button') {
        // 1000001 chemou, 1000002 appliedphysics, 1000003 biobeam (Wannasorn)
        if (
          this.comId == 512 ||
          this.comId == 524 ||
          this.comId == 525 ||
          this.comId == 1000001 ||
          this.comId == 1000002 ||
          this.comId == 1000003
        ) {
          return true;
        }
      } else if (accessObject === 'payment-address-tab') {
        if (this.comId == 502 || this.comId == 503) {
          return true;
        }
      } else if (accessObject === 'img-upload-tab') {
        if (this.comId == 485 || this.comId == 519 || this.comId == 513) {
          return true;
        }
      } else if (accessObject === 'special-membership') {
        if (this.comId == 519 || this.comId == 513 || this.comId == 485) {
          return true;
        }
      } else if (accessObject === 'preq-course') {
        if (openPreqCourse.includes(this.comId)) {
          return true;
        }
      }
    },
  },
};
